import React from 'react';

import InternalContainer from '../../layout/containers/Internal';
import InternalTabs from '../../layout/components/InternalTabs/InternalTabs';
import {
  isBroker,
  isBrokerOrganisation,
  isInsurer,
  isOwner,
} from '../../auth/redux/authActions';
import BordereauxReports from '../components/BordereauxReports/BordereauxReports';
import WeeklyReports from '../components/WeeklyReports/WeeklyReports';
import DailyReports from '../components/DailyReports/DailyReports';
import BrokerStatements from '../components/BrokerStatements/BrokerStatements';

const TAB_NAME = 'reportTabs';

const AccountReportsContainer = ({}) => {
  const tabs = [
    {
      permissions: ['report.bdx', 'report.predefined'],
      title: isBroker() ? 'Reports' : 'MI Reports',
      content: <BordereauxReports />,
    },
  ];

  if (!isBroker() && !isBrokerOrganisation()) {
    tabs.push({
      permissions: ['report.aig_screening'],
      title: 'Weekly Reports',
      content: <WeeklyReports />,
    });
  }

  if (!isBroker() && !isBrokerOrganisation() && !isInsurer()) {
    tabs.push({
      permissions: ['report.bdx', 'report.predefined'],
      title: 'Daily Reports',
      content: <DailyReports />,
    });
  }

  if (isOwner()) {
    tabs.push({
      permissions: ['report.bdx', 'report.predefined'],
      title: 'Broker Statements',
      content: <BrokerStatements />,
    });
  }
  return (
    <InternalContainer title="Reporting">
      <InternalTabs id={TAB_NAME} tabs={tabs} />
    </InternalContainer>
  );
};

export default AccountReportsContainer;
